import {useEffect, useRef} from 'react';

import {useReviewRealtimePresence} from './review-realtime-presence-context';
import {ReviewPresenceActivityOptionsType} from './review-realtime-presence-type';

function getActivitiesSignature(activities: Array<ReviewPresenceActivityOptionsType>): string {
    return activities.map((activity) => `${activity.reviewId}:${activity.brandId}:${activity.action}`).join('|');
}

export function useReviewPresenceActivity(
    activities: Array<ReviewPresenceActivityOptionsType>,
    isActive: boolean
): void {
    const {startActivity, stopActivity} = useReviewRealtimePresence();
    const activitiesRef = useRef(activities);
    const activitiesSignature = getActivitiesSignature(activities);

    activitiesRef.current = activities;

    useEffect(() => {
        const currentActivities = activitiesRef.current;

        if (isActive) {
            currentActivities.forEach((activity) => {
                startActivity(activity);
            });
        }

        return () => {
            if (isActive) {
                currentActivities.forEach((activity) => {
                    stopActivity(activity);
                });
            }
        };
    }, [activitiesSignature, isActive, startActivity, stopActivity]);
}
